import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'monitorAlarm',
    standalone: false
})
export class MonitorAlarmPipe implements PipeTransform {

  statuses = [
    {
      code: 1,
      name: 'Stop',
      color: '#df000f',
      class: 'text-danger'
    },
    {
      code: 2,
      name: 'Standby',
      color: '#000',
      class: 'text-warning'
    },
    {
      code: 4,
      name: 'Running',
      color: '#00d700',
      class: 'text-green'
    },
  ];

  transform(value: number, key: string): string {
    let statusFound = this.statuses.find(status => status.code === value);

    if (statusFound === undefined) {
      statusFound = this.statuses[0];
    }

    return statusFound[key];
  }

}

